import React, { Component } from 'react';
import $ from 'jquery';
import './ButtonStyles.css'

class BackToTopButton extends Component {


    componentDidMount = () => {
        var btn = $('#button');

        $(window).scroll(function () {
            if ($(window).scrollTop() > 300) {
                btn.addClass('show');
            } else {
                btn.removeClass('show');
            }
        });

        btn.on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, '100');
        });

    }

    render() {
        return (
            <div>
                <a id="button"></a>
            </div>
        );
    }
}

export default BackToTopButton;
